import Vue from "vue"
import VueI18n from "vue-i18n"

import loggedIn from "./i18n/loggedIn"
import langDef from "./i18n/langDef"

Vue.use(VueI18n)

export default (context) => {
  const { app, store, route } = context
  var importedLocale

  if (store.getters["user/IS_LOGGED_IN"] && !route.path.includes("signup")) {
    importedLocale = loggedIn(context)
  } else {
    importedLocale = langDef(context)
  }

  store.commit("SET_LANG", importedLocale)

  app.i18n = new VueI18n({
    locale: importedLocale,
    fallbackLocale: "en",
    messages: {
      en: require("~/locales/en.json"),
      fr: require("~/locales/fr.json"),
    },
  })
}
